import { render } from "./SendEmail.vue?vue&type=template&id=765b428e&scoped=true&ts=true"
import script from "./SendEmail.vue?vue&type=script&lang=ts"
export * from "./SendEmail.vue?vue&type=script&lang=ts"

import "./SendEmail.vue?vue&type=style&index=0&id=765b428e&lang=scss&scoped=true"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/BV_HV/DanhGia_FE_HV/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-765b428e"]])

export default __exports__